import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';

import useResize from 'src/shared/hooks/useResize';
import ArticlePostModel from 'src/types/article/ArticlePostModel';
import TitleText from 'src/shared/components/TitleText';
import NewsPreview from 'src/components/NewsPreview';

import styles from './styles.module.scss';
import BREAKPOINT from 'src/shared/config/Breakpoint';

interface Props {
    className: string;
    articles: ArticlePostModel[];
}

const RelatedArticles = (props: Props) => {
    const { t } = useTranslation();
    const { screenSize } = useResize();
    const [itemType, setItemType] = useState('row_left-img');

    useEffect(() => {
        const type = screenSize.width < BREAKPOINT.MD ? 'row_right-img' : 'row_left-img';
        if (itemType !== type) {
            setItemType(type);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screenSize]);

    return (
        <div className={`${styles.container} ${props.className}`}>
            <TitleText tag="h1" className={styles.title}>
                {t('article_related_articles_title')}
            </TitleText>
            {props.articles.map((article, idx) => (
                <NewsPreview key={`related-article-${idx}`} className={styles.relatedArticles} type={itemType} item={article} />
            ))}
        </div>
    );
};

export default RelatedArticles;
